export default "__VITE_ASSET__DVZ1VAMT__"